import { Modal } from './Modal';
import { Header } from './Header';
import { Body } from './Body';
import { Footer } from './Footer';

export const ModalGeneric = {
  Root: Modal,
  Header: Header,
  Body: Body,
  Footer: Footer,
};